<template>
  <div style="height: 100%;">
    <el-container v-if="login || loginCookie" style="height: 100%;" class="box">
      <el-header class="app-header">
        <h3>银关易数字科技服务平台</h3>
      </el-header>
      <el-container style="height: calc(100vh - 60px)">
        <el-aside width="200px">
          <el-menu style="height: 100%;" router :default-active="$route.name">
            <el-menu-item index="businessboard">
              <i class="el-icon-data-analysis"></i>
              <span slot="title">大屏监控</span>
            </el-menu-item>
            <el-menu-item index="company-list">
              <i class="el-icon-s-data"></i>
              <span slot="title">企业列表</span>
            </el-menu-item>
            <el-menu-item index="province">
              <i class="el-icon-s-data"></i>
              <span slot="title">已预授信企业</span>
            </el-menu-item>
            <el-menu-item index="apply-detail">
              <i class="el-icon-s-data"></i>
              <span slot="title">企业申请明细</span>
            </el-menu-item>
            <el-menu-item index="anomaly">
              <i class="el-icon-s-data"></i>
              <span slot="title">企业预授信异动</span>
            </el-menu-item>
            <el-menu-item index="statistics">
              <i class="el-icon-s-data"></i>
              <span slot="title">企业货值统计</span>
            </el-menu-item>
            <el-menu-item index="not-apply-company">
              <i class="el-icon-s-data"></i>
              <span slot="title">未申请企业</span>
            </el-menu-item>
            <el-menu-item index="apply-list">
              <i class="el-icon-s-data"></i>
              <span slot="title">银关易申请报表</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="main">
          <home v-if="$route.name == 'databoard'" />
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <password v-else type="login" />
  </div>
</template>

<script>
import password from '@/components/password';
import home from '@/page/home';
export default {
  name: 'box',
  data() {
    return {
      loginCookie: false
    };
  },
  components: { password, home },
  computed: {
    login() {
      return this.$store.state.login;
    }
  },
  created() {
    this.loginCookie = Boolean(this.$getCookie('login'));
  }
};
</script>

<style></style>
